import { GRAY_TYPE_1, EBreakpoints, PRIMARY_LINK_COLOR } from '@theme/theme';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  list: {
    display: 'flex',
    alignItems: 'center',
    listStyle: 'none',
    paddingLeft: 0,
    margin: 0,
    overflow: 'auto',

    '& .swiper-slide': {
      // Не хочет без !important заводиться
      width: 'auto !important',
    },

    '& .swiper': {
      marginLeft: '0',
    },

    '::-webkit-scrollbar': {
      display: 'none',
    },
  },

  item: {
    display: 'flex',
    alignItems: 'center',
  },

  label: {
    '&&': {
      color: GRAY_TYPE_1,
      '&:not(:last-child)': {
        color: PRIMARY_LINK_COLOR,
        cursor: 'pointer',
      },
    },
  },

  icon: {
    margin: '0 8px',
    height: 7,
    [theme.breakpoints.up(EBreakpoints.desktop)]: {
      height: 12,
      margin: '0 10px',
    },
  },
}));
